import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import data from "../api/databaseApi";

// Component Import
import AddItem from "./AddItem";

const SemesterList = () =>{
    const navigate = useNavigate();
    const [semesters,setSemestersList] = useState([]);
    const getSemesters = data.getSemesters;
    useEffect(() =>{
        const update = async () =>{
            const data = await getSemesters()
            setSemestersList(data);
        }
        update();
    },[getSemesters]);
    const addSemester = async (semesterToAdd) =>{
        const newItem = await data.addSemester(semesterToAdd);
        setSemestersList([...semesters,newItem]);
    }
    const removeSemester = async (semesterIdToRemove) =>{
        data.removeSemester(semesterIdToRemove);
        setSemestersList(semesters.filter((semester) =>{
            if(semester.id !== semesterIdToRemove){
                return semester;
            }
            return null;
        }))
    }
    return (
        <div className="container">
            <table className="table table-striped table-hover table-bordered">
                <thead className="table-dark">
                    <tr>
                        <th scope="col">
                            <span className="row">
                                <div className="col">Semesters</div>
                                <div className="col text-end">Count: {semesters.length}</div>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {semesters.map((semester) =>{
                        return (
                            <tr key={semester.id}>
                                <td>
                                    <div className="row">
                                        <div style={{cursor:"pointer"}} className="col-11" onClick={()=>{navigate(`/class-list/${semester.id}`)}}>
                                            {semester.name}
                                        </div>
                                        <div className="col text-center"><FaTimes style={{cursor:"pointer"}} onClick={()=>{removeSemester(semester.id)}}/></div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                    {semesters.length === 0 && (
                        <tr>
                            <td>No Semesters found</td>
                        </tr>
                    )}
                    <tr>
                        <td>
                            <AddItem title='Add Semester' prompts={[{prompt:"Semester Name",varName:"name",type:"text"}]} addItem={addSemester}/>
                        </td>
                    </tr>
                </tbody>
            </table>
            
        </div>
    )
}

export default SemesterList